import { apiClient } from "./apiClient";
import type { ClientSnapshot } from "@/types/entities";

export const clientSnapshotService = {
  get: (legalEntityId: string) =>
    apiClient.get<ClientSnapshot>("/dashboard/client-snapshot", { params: { legalEntityId } }).then((r) => r.data),
};
